export const odluka_blag_min = {
    templateId: 113,
    category: 4,
    templateTitle: 'Odluka o blagajničkom minimumu',
    templateDescription: `<p>Donošenje ove odluke nije zakonska obveza (kao donošenje odluke o blagajničkom maksimumu) obveznika fiskalizacije koji izdaje račune za plaćanje gotovinom, no svakako se preporuča.</p>`,
    description: `
    <h5><strong>OPIS I SVRHA DOKUMENTA</strong></h5>
    <p>Odlukom o blagajničkom minimumu određuje se najmanji iznos koji smije preostati u blagajni nakon uplate pologa blagajničkog maksimumu.</p>
    <p>Iznos blagajničkog minimuma predstavlja novčani iznos s kojim blagajna određenog poslovnog prostra započinje rad odnosno iznos koji preostaje u blagajni nakon pologa utrška blagajne na poslovni račun obveznika fiskalizacije.</p>

    `,
    sides: [
        {
            signature: 'Za Obveznika fiskalizacije:',
            inputs: [{
                type: "input",
                required: true,
                placeholder: "Poslovni subjekt",
              },
              {
                type: "input",
                required: true,
                placeholder: "Ulica i kućni broj",
              },
              {
                type: "input",
                required: true,
                placeholder: "Mjesto",
              },
              {
                type: "input",
                required: true,
                placeholder: "OIB",
              },
              {
                type: "input",
                placeholder: "Zastupa",
                inSignature: true,
              },
              {
                type: "input",
                placeholder: "Funkcija",
                inSignature: true,
              }],
            suffix: ' (u daljnjem tekstu: Obveznik fiskalizacije),',
        }
    ],

    headline: '​donosi sljedeću',
    title: 'ODLUKU O BLAGAJNIČKOM MINIMUMU',
    noArticleNumbers: true,

    articles: [
      
       
        {
            title: "",
            mandatory: true,
            statements: [
              {
                type: "input",
                mandatory: true,
                parts: [
                    { type: "text", content: "Za potrebe redovnog poslovanja utvrđuje se da blagajnički minimum u iznosu od " },
                    { type: "input", value: "", required: true },
                    { type: "text", content: "kn. " },
                ],
              }
            ]
          },
        {
            title: '',
            mandatory: false,
            statements: [
                {
                    type: 'text',
                    required: true,
                    mandatory: true,
                    editable: true,
                    content: 'Svi zaposlenici poslodavca odgovorni za blagajničko poslovanje obvezni su u odnosu na određeni iznos blagajničkog minimuma pridržavati se odredbi ove Odluke.',
                    value: '',
                },
            ],
            value: '',
        }, 
          {
            title: "",
            mandatory: true,
            statements: [
              {
                type: "input",
                mandatory: true,
                parts: [
                    { type: "text", content: "Ova Odluka se primjenjuje od dana" }, 
                    { type: "input", value: "", required: true },
                    { type: "text", content: "godine."}, 
                ],
              }
            ]
          },
        {
            mandatory: true,
            static: true,
            type: 2, // date and place
            statements: [
                {
                    type: 'input',
                    mandatory: true,
                    parts: [
                        {
                            type: 'text',
                            content: 'U'
                        },
                        {
                            type: 'input',
                            value: '',
                            placeholder: "Upišite mjesto.",
                            required: true
                        },
                        {
                            type: 'text',
                            content: ', dana'
                        },
                        {
                            type: 'date',
                            value: new Date(),
                            required: true
                        },
                        {
                            type: 'text',
                            content: 'godine.',
                        }
                    ]
                },
            ]
        },
        {
            mandatory: true,
            static: true,
            type: 3,  // signatures
            statements: [],
        },
        {
            static: true,
            mandatory: false,
            type: 4, 
            statements: [
                {
                    type: 'text',
                    mandatory: true,
                    editable: true,
                    content: 'Dostaviti:\r\n1) Poslovni prostor Obveznika fiskalizacije \r\n2) Arhiva',
                    help: 'Po želji, slobodno dopišite kome želite dostaviti odluku odnosno izmijenite/obrišite predložene unose.'
                }
            ]
        },
    ],
};





// WEBPACK FOOTER //
// C:/Projects/milic/self-legal/src/app/contracts/113_odluka_blag_min.ts